module.exports = __webpack_public_path__ + "img/9791195265244.5bf98b6e.jpg";